import type { PropsWithChildren } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TrackingProvider } from '@izimi/components';
import { createConfigurationLinks } from '@izimi/core';
import config from 'core/config';
import { usePortalConfiguration } from 'core/modules/public';

export const CitizenPortalTrackingProvider = ({ children }: PropsWithChildren) => {
  const {
    i18n: { language },
  } = useTranslation();

  const { configuration } = usePortalConfiguration();

  const { cookieUrl } = useMemo(
    () => createConfigurationLinks(configuration, language, `https://www.izimi.be`),
    [configuration, language],
  );

  const tracking = useMemo(
    () =>
      configuration?.analytics
        ? {
            siteId: configuration.analytics.id,
            url: config.apiUrl,
            trackerUrl: configuration.analytics.trackerUrl,
            srcUrl: configuration.analytics.srcUrl,
          }
        : null,
    [configuration],
  );

  return (
    <TrackingProvider config={tracking} cookieUrl={cookieUrl} withPageTracker={false}>
      {children}
    </TrackingProvider>
  );
};
